<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJsonValidate()" 
    (onRunTransform)="onRunTransformValidate()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="viewModel?.sourceColumn ?? ''"
    [availableSourceFields]="groupAttributorAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex;margin-top:-10px;margin-left: -3px;">
                <div style="margin-right: 10px;">
    <!--<div style="display: flex; align-items: center;" >
                     
   <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
  <mat-label>
    {{ sourceColumn.label }}
  </mat-label>

  <mat-select formControlName="defSourceField" [required]="sourceColumn.isrequired">
    <mat-option *ngIf="sourceColumn.isselectblank" [value]="null"></mat-option>
    <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">
      {{ col.text }}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="formparam.get('defSourceField')?.hasError('required') && 
                    formparam.get('defSourceField')?.touched">
    {{ sourceColumn.label }} is required
  </mat-error>
</mat-form-field>

                        <div style="width: 24px;margin-left: 5px;">
                            <img *ngIf="sourceColumn.isfillrules" (click)="onSetDefaultRuleParam('sourceColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div>
                    </div>-->
  <div style="display: flex; align-items: center;" [formGroup]="formparam">
  <app-autocomplete-field-with-matform
    formControlName="defSourceField"
    [options]="viewModel.OptionsourceColumns"
   [placeholder]="sourceColumn?.label || 'Default Start Field'"
    [(ngModel)]="viewModel.sourceColumn"
    [required]="true"
  ></app-autocomplete-field-with-matform>

  <div style="width: 24px;margin-left: 5px;">
    <img *ngIf="sourceColumn.isfillrules"
         (click)="onSetDefaultRuleParam('sourceColumn')"
         src="assets/images/Fill Column Icon.png"
         alt="Set Default Rules"
         width="24px"
         height="28px">
  </div>

</div>
<!-- ✅ Force error below entire row using full-width div -->
<div style="flex-basis: 100%; width: 100%;">
  <mat-error *ngIf="formparam.get('defSourceField')?.hasError('required') && 
                    formparam.get('defSourceField')?.touched">
    {{ sourceColumn.label }} is required
  </mat-error>
</div>
                  <!--  <div style="display: flex; align-items: center;" >
                        <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{targetColumn.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.targetColumn" [required]="targetColumn.isrequired" formControlName="defTargetField">
                                <mat-option *ngIf="targetColumn.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('defTargetField').hasError('required')">Target Field is required</mat-error>
                        </mat-form-field>
                        <div style="width: 24px;margin-left: 5px;">
                            <img *ngIf="targetColumn.isfillrules" (click)="onSetDefaultRuleParam('targetColumn')" src="assets/images/Fill Column Icon.png" alt="Set Default Rules" width="24px" height="28px">
                        </div>
                    </div>-->
 <div style="display: flex; align-items: center;" [formGroup]="formparam">
  <app-autocomplete-field-with-matform
    formControlName="defTargetField"
    [options]="viewModel.OptionsourceColumns"
    [placeholder]="targetColumn.label  || 'Default End Field'"
    [(ngModel)]="viewModel.targetColumn"
    [required]="true"
  ></app-autocomplete-field-with-matform>

  <div style="width: 24px;margin-left: 5px;">
    <img *ngIf="sourceColumn.isfillrules"
         (click)="onSetDefaultRuleParam('targetColumn')"
         src="assets/images/Fill Column Icon.png"
         alt="Set Default Rules"
         width="24px"
         height="28px">
  </div>

</div>
<!-- ✅ Force error below entire row using full-width div -->
<div style="flex-basis: 100%; width: 100%;">
  <mat-error *ngIf="formparam.get('defTargetField')?.hasError('required') && 
                    formparam.get('defTargetField')?.touched">
   {{ targetColumn.label }} is required
  </mat-error>
</div>
                </div>
            <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)" (eventTimeColumn)="onEventTimeColumn()"></app-transformer-parameters>
            </div>
            <div style="display: flex">
                <div style="margin-right: 18px;">
                    <div style="display: flex; align-items: center;" [formGroup]="formparam">

                    <app-autocomplete-field-with-matform
                    formControlName="groupByField"
                    [options]="viewModel.OptionsourceColumns"
                     [placeholder]="groupBy.label|| 'Group By'"
                    [(ngModel)]="viewModel.groupBy"
                    [required]="true"
                ></app-autocomplete-field-with-matform>
                        
                                    <!--<mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{groupBy.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.groupBy" [required]="groupBy.isrequired" formControlName="groupByField">
                                <mat-option *ngIf="groupBy.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">
                                    {{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('groupByField').hasError('required')">{{viewModel.getValidationInfo('groupByField').errorMessage}}</mat-error>
                        </mat-form-field>-->

                        <div style="width: 24px;margin-left: 5px;"></div>
                    </div>
                    <!-- ✅ Force error below entire row using full-width div -->
                <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('groupByField')?.hasError('required') && 
                                    formparam.get('groupByField')?.touched">
                    {{ groupBy.label }} is required
                </mat-error>
                </div>
                </div>
                <div style="margin-right: 10px;">
                    <div style="display: flex; align-items: center;"  [formGroup]="formparam">
                       <!-- <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{separateBy.label}}</mat-label>
                            <mat-select (selectionChange)="onSeparateByChanged($event)" [(ngModel)]="viewModel.separateBy" [required]="separateBy.isrequired" formControlName="separateBy">
                                <mat-option *ngIf="separateBy.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">
                                    {{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('separateBy').hasError('required')">{{viewModel.getValidationInfo('separateBy').errorMessage}}</mat-error>
                        </mat-form-field>-->
                          <app-autocomplete-field-with-matform
                    formControlName="separateBy"
                    [options]="viewModel.OptionsourceColumns"
                     [placeholder]="separateBy.label|| 'Separate By'"
                    [(ngModel)]="viewModel.separateBy"
                    [required]="true"
                    (selectionChange)="configureDefaultSortBy()"
                ></app-autocomplete-field-with-matform>
                    </div>
                    <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('separateBy')?.hasError('required') && 
                                    formparam.get('separateBy')?.touched">
                    {{ separateBy.label }} is required
                </mat-error>
                </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="formparam">
                            <mat-label>{{defTimeout.label}}</mat-label>
                            <input matInput formControlName="defTimeout" placeholder="Timeout" type="number" [required]="defTimeout.isrequired" [min]="defTimeout.min" [max]="defTimeout.max"
                                [(ngModel)]="viewModel.defTimeout" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="formparam">
                            <mat-label>{{defInclude.label}}</mat-label>
                            <input matInput formControlName="defInclude" placeholder="Sample End" type="number" [required]="defInclude.isrequired" [min]="defInclude.min" [max]="defInclude.max"
                                [(ngModel)]="viewModel.defInclude" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top: 15px;">
            <mat-expansion-panel-header>Advanced Settings<span *ngIf="isValidateAdvanceSettings" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex">
                <div style="margin-right: 10px;margin-top:-10px;margin-left: -2px;">
                    <div style="margin-top: 10px;">
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{bufferRows.label}}</mat-label>
                            <input matInput formControlName="bufferRows" type="number" placeholder="Buffer Rows" [(ngModel)]="viewModel.bufferRows" [required]="bufferRows.isrequired" [min]="bufferRows.min" [max]="bufferRows.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{threads.label}}</mat-label>
                            <input matInput formControlName="threads" type="number" placeholder="Threads" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{listSeparator.label}}</mat-label>
                            <input matInput formControlName="separatorControl" type="text" [(ngModel)]="viewModel.listSeparator" [required]="listSeparator.isrequired" placeholder="Select the Separator."
                            [matAutocomplete]="autolistSeparator"
                            >
                            <mat-autocomplete autoActiveFirstOption #autolistSeparator="matAutocomplete">
                                <mat-option *ngFor="let separator of separatorOptions | async" [value]="separator.value">
                                    {{separator.text}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-slide-toggle style="margin-top: 25px;" labelPosition="before" color="primary" (change)="onToggleResetRows($event)" [checked]="viewModel.resetRows" ><span [innerHTML]="resetRows.label"></span></mat-slide-toggle>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div class="white-text-form">
                        <mat-form-field>
                            <mat-label>{{fillOptionType.label}}</mat-label>
                            <mat-select [(value)]="viewModel.fillOptionType">
                                <mat-option *ngIf="fillOptionType.isselectblank"></mat-option>
                                <mat-option [value]=FillOptionType.skipGroupStrings>{{FillOptionTypeUtil.toString(FillOptionType.skipGroupStrings)}}</mat-option>
                                <mat-option [value]=FillOptionType.includeGroupStrings>{{FillOptionTypeUtil.toString(FillOptionType.includeGroupStrings)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-slide-toggle style="margin-top: 25px;" labelPosition="before" color="primary" (change)="onUpdateGroupsAtEnd($event)" [checked]="viewModel.updateGroupsAtEnd" ><span [innerHTML]="updateGroupsAtEnd.label"></span></mat-slide-toggle>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 30px;">Rules</span>

                    <button 
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule"  class="add-rule-btn" style="height: 24px;border-radius: 2px;">
                        <mat-icon >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                       color="primary"
                        mat-raised-button title="Show All" class="rule-toggle-btn" style=" line-height: 24px;height: 24px;border-radius: 2px;">
                        <mat-icon >{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                        <!-- {{isRulesMaximized ? 'MINIMIZE' : 'MAXIMIZE'}} -->
                    </button>

                </div>

            </mat-expansion-panel-header>
            <!-- [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div 
                style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray !important" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">

                            <div
                                style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                               <!-- <mat-icon color="primary" matTooltip="Re-order Rule" style="cursor: grab" cdkDrag
                                    [cdkDragData]="rule" cdkDragRootElement=".drag-component" cdkDragHandle>reorder
                                </mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" class="icon"
                                    (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">
                                    control_point_duplicate</mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)"
                                    matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>-->
                                    <mat-icon color="primary"
                                    style="cursor: grab" 
                                    cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component"
                                    cdkDragHandle
                                    matTooltip="Re-order Rule"  
                                    matTooltipPosition="below"
                                    #reorderTooltip="matTooltip"
                                    (mouseenter)="reorderTooltip.show()"
                                    (mouseleave)="reorderTooltip.hide()"
                                    >reorder</mat-icon>
        
                                    <mat-icon style="margin-left: 4px; cursor: pointer" 
                                    class="icon" 
                                    (click)="onDuplicateRule(rule)" 
                                    matTooltip="Duplicate Rule" 
                                    matTooltipPosition="below"
                                    #duplicateTooltip="matTooltip"
                                    (mouseenter)="duplicateTooltip.show(); 
                                    reorderTooltip.hide()"
                                    (mouseleave)="duplicateTooltip.hide()"
                                    color="primary">
                                    control_point_duplicate
                                   </mat-icon>
                                   <mat-icon style="margin-left: 2px; cursor: pointer"
                                    (click)="onDeleteRule(rule)" 
                                    matTooltip="Delete Rule" 
                                    matTooltipPosition="below"
                                    #deleteTooltip="matTooltip"
                                    (mouseenter)="deleteTooltip.show(); duplicateTooltip.hide(); reorderTooltip.hide()"
                                    (mouseleave)="deleteTooltip.hide()"
                                    class="red-icon">
                                    delete_forever
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Start - Top Column Header Groups -->
                    <ng-container matColumnDef="groupOptionsHeader">
                        <th mat-header-cell style="color:#D9D9D9 !important;" class="center-text" *matHeaderCellDef
                            [attr.colspan]="5">Grouping Options</th>
                        <!-- <td mat-cell *matCellDef="let data">Test Header Value</td> -->
                    </ng-container>

                    <ng-container matColumnDef="startGroupHeader">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important; color: #98FB00 !important;" class="center-text"
                            *matHeaderCellDef [attr.colspan]="5">Start Group</th>
                        <!-- <td mat-cell *matCellDef="let data">Test Header Value</td> -->
                    </ng-container>

                    <ng-container matColumnDef="endGroupHeader">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important; color: orange !important;" class="center-text"
                            *matHeaderCellDef [attr.colspan]="5">End Group</th>
                        <!-- This column doesn't generate <td> items, so no need to add a definition for them -->
                    </ng-container>

                    <ng-container matColumnDef="generalGroupHeader">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important; color: #D9D9D9 !important;" class="center-text"
                            *matHeaderCellDef [attr.colspan]="3">General</th>
                        <!-- This column doesn't generate <td> items, so no need to add a definition for them -->
                    </ng-container>

                    <ng-container matColumnDef="statsGroupHeader">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important; color: #D9D9D9 !important;" class="center-text"
                            *matHeaderCellDef [attr.colspan]="4">Stats</th>
                        <!-- This column doesn't generate <td> items, so no need to add a definition for them -->
                    </ng-container>

                    <!-- End - Top Column Header Groups -->

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Rule Name </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box" [(ngModel)]="rule.ruleName" appAutowidth>
                        </td>
                    </ng-container>

                    <!-- Grouping -->
                    <ng-container matColumnDef="groupFill">
                        <th mat-header-cell *matHeaderCellDef> Fill With </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.groupFill">
                                <mat-option *ngFor="let type of GroupFillTypes" [value]="type">
                                    {{GroupFillTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="groupByValue">
                        <th mat-header-cell *matHeaderCellDef> Value </th>
                        <td mat-cell *matCellDef="let rule">
                            <input [disabled]="rule.groupFill !== GroupFillType.value" type="text"
                                style="border: none; box-sizing: border-box"
                                [(ngModel)]="rule.groupByValue" appAutowidth>
                        </td>
                    </ng-container>

                    <!-- Start Group -->
                  <!--  <ng-container matColumnDef="fieldStart">
                        <th mat-header-cell style="border-left: 1px solid #ffa600;" *matHeaderCellDef
                            style="border-left: 1px solid #ffa600;"> Field</th>
                        <td mat-cell style="border-left: 1px solid #ffa600;" *matCellDef="let rule"
                            style="border-left: 1px solid #ffa600;" class="auto-width">
                            <mat-select [(value)]="rule.fieldStart">
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>-->
                    <ng-container matColumnDef="fieldStart">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important;" *matHeaderCellDef
                            style="border-left: 1px solid #ffa600 !important;"> Field</th>
                        <td mat-cell style="border-left: 1px solid #ffa600 !important;" *matCellDef="let rule"
                            style="border-left: 1px solid #ffa600 !important;" class="auto-width">
                          
                                  <app-autocomplete-field 
                [options]="options"    
                [placeholder]="defaultSourceColumn" 
               [(ngModel)]="rule.fieldStart"
                ></app-autocomplete-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="whenStart">
                        <th mat-header-cell *matHeaderCellDef> When </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-select [(ngModel)]="rule.whenStart" style="width:120px">
                                <mat-option *ngFor="let type of StartGroupWhenTypes" [value]="type">
                                    {{WhenTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="conditionStart">
                        <th mat-header-cell *matHeaderCellDef> And </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.conditionStart">
                                <mat-option *ngFor="let type of ConditionTypes" [value]="type">
                                    {{ConditionTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="stringStart">
                        <th mat-header-cell *matHeaderCellDef> String </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box"
                                [(ngModel)]="rule.stringStart" appAutowidth></td>
                    </ng-container>

                    <ng-container matColumnDef="groupByStart">
                        <th mat-header-cell *matHeaderCellDef> Group By </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-select [(ngModel)]="rule.groupByStart">
                                <mat-option *ngFor="let type of GroupByTypes" [value]="type">
                                    {{GroupByTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <!-- End Group -->
                    <!--<ng-container matColumnDef="fieldEnd">
                        <th mat-header-cell style="border-left: 1px solid #ffa600;" *matHeaderCellDef> Field</th>
                        <td mat-cell style="border-left: 1px solid #ffa600;" *matCellDef="let rule" class="auto-width">
                            <mat-select [(value)]="rule.fieldEnd">
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>-->
                    <ng-container matColumnDef="fieldEnd">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important;" *matHeaderCellDef> Field</th>
                        <td mat-cell style="border-left: 1px solid #ffa600 !important;" *matCellDef="let rule" class="auto-width">
                         <app-autocomplete-field 
                        [options]="options" 
                        [placeholder]="defaultTargetColumn" 
                        [(ngModel)]="rule.fieldEnd">
                        </app-autocomplete-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="whenEnd">
                        <th mat-header-cell *matHeaderCellDef> When </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.whenEnd">
                                <mat-option *ngFor="let type of WhenTypes" [value]="type">
                                    {{WhenTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="conditionEnd">
                        <th mat-header-cell *matHeaderCellDef> And </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [disabled]="rule.whenEnd === WhenType.notInGroup"
                                [(ngModel)]="rule.conditionEnd">
                                <mat-option *ngFor="let type of ConditionTypes" [value]="type">
                                    {{ConditionTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="stringEnd">
                        <th mat-header-cell *matHeaderCellDef> String </th>
                        <td mat-cell *matCellDef="let rule"><input [disabled]="rule.whenEnd === WhenType.notInGroup"
                                type="text" style="border: none; box-sizing: border-box"
                                [(ngModel)]="rule.stringEnd" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="groupByEnd">
                        <th mat-header-cell *matHeaderCellDef> Group By </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-select [(ngModel)]="rule.groupByEnd">
                                <mat-option *ngFor="let type of GroupByTypes" [value]="type">
                                    {{GroupByTypeUtil.toString(type)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <!-- General -->
                    <ng-container matColumnDef="timeout">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important;text-align: center;" *matHeaderCellDef> Timeout
                            (s) </th>
                        <td mat-cell style="border: none; border-left: 1px solid #ffa600 !important;" *matCellDef="let rule"><input
                                type="number" [min]="0" style="width:45px; box-sizing: border-box;"
                                [(ngModel)]="rule.timeout" appIntegerPositiveOnly></td>
                    </ng-container>

                    <ng-container matColumnDef="include">
                        <th mat-header-cell style="text-align: center;" *matHeaderCellDef> Include
                            (s) </th>
                        <td mat-cell *matCellDef="let rule"><input type="number" [min]="0"
                                style="width:45px; box-sizing: border-box;" [(ngModel)]="rule.include" appIntegerPositiveOnly></td>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef> Run? <mat-slide-toggle (change)="onRunChanged($event)"
                                color="primary"></mat-slide-toggle>
                        </th>

                        <td mat-cell *matCellDef="let rule">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleGroups">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important;" *matHeaderCellDef> Sample Group Hits
                        </th>
                        <td mat-cell style="border-left: 1px solid #ffa600 !important;" *matCellDef="let rule">
                            {{rule.sampleGroupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleRows">
                        <th mat-header-cell *matHeaderCellDef> Sample Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.sampleRowHits | number}} </td>
                    </ng-container>

                    <ng-container matColumnDef="groups">
                        <th mat-header-cell *matHeaderCellDef> Total Group Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.groupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="rows">
                        <th mat-header-cell *matHeaderCellDef> Total Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.rowHits | number}} </td>
                    </ng-container>

                    <tr mat-header-row
                        *matHeaderRowDef="['groupOptionsHeader', 'startGroupHeader', 'endGroupHeader', 'generalGroupHeader', 'statsGroupHeader']">
                    </tr>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                   <!-- <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
                  <tr
                class="drag-component"
                mat-row
                *matRowDef="let row; columns: displayedColumns;"
                (click)="onRowClicked($event, row)"
                [ngClass]="{'highlight-row': selectedRows.includes(row)}">
                </tr>


                    <div *cdkDragPlaceholder></div>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setGroupAttributorResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 110px; margin-left: 3px;" appearance="outline">
                                <mat-label>Group Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits"
                                    [value]="viewModel.groupHitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 92px; margin-left: 3px" appearance="outline">
                                <mat-label>Row Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits" [value]="viewModel.hitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 130px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hit Ratio</mat-label>
                                <input type="text" readonly matInput placeholder="Row Hit Ratio"
                                    [(ngModel)]="viewModel.hitRatioDisplay">
                            </mat-form-field>
                            <mat-form-field style="width: 90px; margin-left: 3px;" appearance="outline">
                                <mat-label>Misses</mat-label>
                                <input type="text" readonly matInput placeholder="Misses"
                                    [value]="viewModel.missCount | number">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setGroupAttributorPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>